import React from 'react';
import './HeroSection.css';

const HeroSection = ({ onStartQuiz }) => {
    return (
        <section className="hero">
            <div className="hero-container">
                {/* Lado Esquerdo - Conteúdo */}
                <div className="hero-content">
                    {/* Rating Badge */}
                    <div className="hero-rating">
                        <div className="stars">
                            {[...Array(5)].map((_, i) => (
                                <svg key={i} className="star-icon" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                </svg>
                            ))}
                        </div>
                        <span className="rating-text">Rated 4.9/5 by 10,000+ women</span>
                    </div>

                    {/* Headline */}
                    <h1 className="hero-title">
                        Find Your Perfect
                        <span className="hero-title-accent"> Menopause </span>
                        Solution
                    </h1>

                    {/* Subheadline */}
                    <p className="hero-subtitle">
                        Take our personalized 2-minute quiz and discover science-backed
                        supplements tailored to your unique symptoms. No more guesswork.
                    </p>

                    {/* CTAs */}
                    <div className="hero-ctas">
                        <button className="btn-primary hero-btn" onClick={onStartQuiz}>
                            Start Your Free Quiz
                            <svg className="btn-arrow" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                        </button>
                        <a href="#how-it-works" className="btn-secondary">
                            How it works
                        </a>
                    </div>

                    {/* Trust Badges */}
                    <div className="hero-trust">
                        <div className="trust-item">
                            <svg className="trust-icon" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                            <span>100% Free</span>
                        </div>
                        <div className="trust-item">
                            <svg className="trust-icon" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                            <span>2 Minutes</span>
                        </div>
                        <div className="trust-item">
                            <svg className="trust-icon" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                            <span>Science-Backed</span>
                        </div>
                    </div>
                </div>

                {/* Lado Direito - Imagem */}
                <div className="hero-image-wrapper">
                    <div className="hero-image-container">
                        <img
                            src="/images/hero-woman.png"
                            alt="Confident woman in her 50s smiling, representing menopause wellness"
                            className="hero-image"
                        />
                        {/* Floating Card */}
                        <div className="hero-floating-card">
                            <div className="floating-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" />
                                </svg>
                            </div>
                            <div className="floating-content">
                                <span className="floating-number">94%</span>
                                <span className="floating-text">Found relief</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Partners/Trust Bar */}
            <div className="hero-partners">
                <p className="partners-label">As featured in:</p>
                <div className="partners-logos">
                    <span className="partner-logo">Forbes Health</span>
                    <span className="partner-logo">Healthline</span>
                    <span className="partner-logo">Women's Health</span>
                    <span className="partner-logo">WebMD</span>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
